module.exports = __webpack_public_path__ + "img/plus-blancTransparent.6925110.png";